import { Link } from "react-router-dom";
import Backup from "../assets/images/backup.png";

export const Card = ({ movie }) => {
  const { id, original_title, overview, poster_path } = movie;
  const image = poster_path
    ? `https://image.tmdb.org/t/p/w500${poster_path}`
    : Backup;

  return (
    <div className="max-w-sm rounded-xl overflow-hidden shadow-lg m-4 transform transition duration-300 hover:scale-105 hover:shadow-2xl bg-white dark:bg-gray-900">
      <Link to={`/movie/${id}`}>
        <div className="w-full aspect-[2/3]">
          <img
            className="w-full h-full object-cover hover:opacity-90 transition-opacity duration-300"
            src={image}
            alt={original_title}
          />
        </div>
      </Link>
      <div className="p-5 text-black dark:text-white">
        <Link to={`/movie/${id}`}>
          <h5 className="mb-2 text-2xl font-bold hover:text-teal-600 dark:hover:text-teal-400 transition-colors duration-300">
            {original_title}
          </h5>
        </Link>
        <p className="mb-3 text-sm">
          {overview.length > 120 ? overview.slice(0, 120) + "..." : overview}
        </p>
        <Link
          to={`/movie/${id}`}
          className="inline-block px-4 py-2 bg-teal-500 text-black font-semibold rounded-full hover:bg-teal-400 transition duration-300 text-sm"
        >
          More
        </Link>
      </div>
    </div>
  );
};
